/* ============================================================
   S4H - "Hol dir den Look": Kaufansicht, Warenkorb, Wunschliste

   Gehoert zu sections/s4h-looks.liquid. Eigene Datei, weil die
   Section mit diesem Skript zusammen ueber 21 KB gross waere
   und sich dann nicht mehr am Stueck schreiben liesse.

   Aus Liquid kommt an .s4h-lk:
     data-korb-url    Ziel fuer /cart/add.js
     data-warenkorb   Adresse des Warenkorbs

   ------------------------------------------------------------
   GROESSEN IN DER LISTE (31.08.)

   Laura: "man kann ein Produkt nur in den Warenkorb packen,
   wenn man schon die Groesse eingestellt hat" - und: "Das
   Gleiche bitte ueberall einfuehren."

   Vorher liess Liquid alles aus, was eine Groesse braucht: von
   vier Teilen ging eines in den Korb, die anderen standen als
   Fussnote darunter. Jetzt haengt assets/s4h-groessen.js an
   jede offene Zeile ein Auswahlfeld - dieselbe Datei, die auch
   das Pop-up auf der Startseite benutzt. Der Knopf nimmt IMMER
   alle Teile und nennt die Summe erst, wenn nichts mehr offen
   ist.

   Der Hinweis darunter bleibt kurz und rot (Laura: "einfach ein
   roter, kurzer Hinweis"). WELCHE Zeile gemeint ist, sagt beim
   Druecken der rote Rahmen am Feld.

   ------------------------------------------------------------
   DIE ZURUECK-TASTE DES BROWSERS (01.09.)

   Laura: "wenn ich auf 'Kaufe den Look' klicke und dann wieder
   zurueck moechte, lande ich auf der Neuheitenseite. Ich
   muesste aber auf der Seite 'Hol dir den Look' landen."

   Der Grund: die Kaufansicht ist kein Seitenwechsel. Sie tauscht
   nur den Inhalt im selben Dokument aus - keine neue Adresse,
   kein neuer Eintrag im Verlauf. Deshalb bekommt das Oeffnen
   einen eigenen Eintrag im Verlauf (history.pushState mit
   #look-l1). Zurueck schliesst damit erst die Kaufansicht; noch
   einmal Zurueck fuehrt zur vorherigen Seite. Der Knopf
   "Zurueck" in der Ansicht ruft dasselbe auf, damit Verlauf und
   Bild nicht auseinanderlaufen.

   NEBENEFFEKT, DER GEWOLLT IST: die Adresse mit #look-l1 laesst
   sich weitergeben und oeffnet den Look direkt.

   history.pushState kann in seltenen Faellen werfen (sehr alte
   Browser, sehr viele Eintraege). Dann bleibt alles wie vorher
   - die Ansicht funktioniert, nur die Zurueck-Taste nicht.
   Deshalb steht es in try/catch und nicht davor.

   ------------------------------------------------------------
   POP-UP STATT SEITENWECHSEL (04.09.)

   Laura: "wenn man auf die bilder klickt sollen die produkte
   als popup angezeigt werden, die die person traegt so wie bei
   shop the look."

   Bis heute war die Kaufansicht ein Ansichtswechsel im Fluss
   der Seite: Ueberschrift und Raster wurden ausgeblendet, die
   Section davor (das Kopfbild) auf display:none gesetzt. Das
   sah aus wie eine neue Seite und war doch keine.

   Jetzt legt sich .s4h-lk__detail als Ebene ueber die Seite.
   WICHTIG, weil es genau der Fehler vom 30.08. war (Laura:
   "Kopf und Fuss sind gar nicht mehr da"): der Schleier ist
   halbtransparent, das Raster bleibt stehen, die Section davor
   wird NICHT mehr versteckt. Man sieht, wo man ist.

   DREI DINGE, DIE DIESER UMBAU BRAUCHT:

   1. AM <body>. Ein Vorfahr mit transform, filter oder
      contain macht position:fixed wirkungslos - die Ebene
      haenge dann im Abschnitt statt im Fenster. Themes bringen
      solche Regeln ueber Scroll-Animationen mit. Deshalb wird
      .s4h-lk__detail einmalig an den <body> gehaengt. Die
      Farbvariablen (--lk-fg ...) stehen als style-Attribut auf
      .s4h-lk und werden mit umgezogen, sonst faellt die
      Schriftfarbe im Kasten aus.

      Folge: das Overlay ist kein Nachfahre von .s4h-lk mehr.
      Der Klick-Zuhoerer haengt deshalb an beiden.

   2. DER KASTEN WIRD HIER GEBAUT, nicht in Liquid. Die Section
      liegt mit 20,7 KB nah an der Grenze, ab der sie sich nicht
      mehr am Stueck senden laesst. Der Kasten ist reine
      Darstellung - Pfad, Ueberschrift und Liste bleiben, wie
      Liquid sie liefert, und werden nur umgehaengt.

   3. BFSG. role="dialog", aria-modal="true", ein aria-label aus
      der Ueberschrift, Fokus beim Oeffnen in den Kasten und
      beim Schliessen zurueck auf das Bild, das ihn geoeffnet
      hat, Tab bleibt im Kasten. Schliessen geht auf drei Wegen:
      Knopf, Klick auf den Schleier, Escape.

   Warenkorb, Groessenwahl, Wunschliste, Produktliste und der
   Verlauf sind UNVERAENDERT. Umgebaut ist nur die Darstellung.
   ============================================================ */

(function () {
  'use strict';

  var WUNSCH_KEY = 's4h-wishlist';

  /* Was den Tab-Fokus annehmen kann. Reicht fuer diesen Kasten:
     Links, Knoepfe, Auswahlfelder aus s4h-groessen.js. */
  var FOKUSSIERBAR = 'a[href], button:not([disabled]), select:not([disabled]), '
    + 'input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function gr() { return window.S4hGroessen || null; }

  function melden(detail, text) {
    var m = detail.querySelector('.s4h-lk__meldung');
    if (m) m.textContent = text;
  }

  /* ---- Knopf beschriften ---------------------------------- */

  function knopfMalen(detail) {
    var g = gr();
    var korb = detail.querySelector('.s4h-lk__knopf--korb');
    if (!korb || !g) return;

    var s = g.stand(detail);
    var wieviele = s.n === 1 ? 'Ein Teil' : 'Alle ' + s.n + ' Teile';
    korb.textContent = s.offen.length
      ? wieviele + ' in den Warenkorb'
      : wieviele + ' in den Warenkorb · ' + g.geld(s.summe);

    var hinweis = detail.querySelector('.s4h-lk__offen');
    if (hinweis) hinweis.textContent = s.kurz;
  }

  /* ---- Warenkorb ------------------------------------------ */

  function inKorb(lk, detail, knopf) {
    var g = gr();
    if (!g) return;

    var s = g.stand(detail);
    if (s.offen.length) {
      /* Kein zweiter Satz: der rote Hinweis steht schon da, und
         markieren() faerbt die Felder, um die es geht. */
      melden(detail, '');
      g.markieren(detail);
      return;
    }
    if (!s.ids.length) return;

    var posten = [];
    for (var i = 0; i < s.ids.length; i++) posten.push({ id: s.ids[i], quantity: 1 });

    var addUrl = lk.getAttribute('data-korb-url') || '/cart/add';
    var cartUrl = lk.getAttribute('data-warenkorb') || '/cart';

    knopf.disabled = true;
    melden(detail, 'Wird hinzugefügt …');

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: posten })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (d) {
        throw new Error(d.description || d.message || 'Fehler');
      });
    }).then(function () {
      melden(detail, 'Im Warenkorb. Einen Moment …');
      setTimeout(function () { window.location.href = cartUrl; }, 600);
    })['catch'](function (err) {
      knopf.disabled = false;
      melden(detail, 'Hat nicht geklappt: '
        + (err && err.message ? err.message : 'bitte noch einmal versuchen') + '.');
    });
  }

  /* ---- Wunschliste ----------------------------------------
     Schluessel und Format wie in assets/custom-script.js - dort
     haengt der Zaehler im Kopfbereich daran.

     DIE FARBE BLEIBT (31.08.)
     Laura: "Wenn man alles auf die Wunschliste packt, aendern
     sich aber die Farben. Sie sollten am besten so bleiben."
     Gemerkt wurde bis dahin nur der Artikel; die Wunschlisten-
     seite nahm dann die erste lieferbare Variante.

     Jetzt wird die Variante mitgenommen - die gewaehlte, wenn
     es eine gibt, sonst die aus dem Link. Die Wunschliste nimmt
     IMMER alle Teile, auch die ohne Groesse: sie ist zum Merken
     da, nicht zum Kaufen.
     -------------------------------------------------------- */

  function lesen() {
    try {
      var roh = window.localStorage.getItem(WUNSCH_KEY);
      var p = roh ? JSON.parse(roh) : [];
      return Array.isArray(p) ? p : [];
    } catch (e) { return []; }
  }

  function zaehlerMalen(liste) {
    var nodes = document.querySelectorAll('[data-s4h-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = liste.length ? String(liste.length) : '';
      nodes[i].hidden = liste.length === 0;
    }
    var herzen = document.querySelectorAll('[data-s4h-fav]');
    for (var q = 0; q < herzen.length; q++) {
      var k = herzen[q].getAttribute('data-handle') || herzen[q].getAttribute('data-s4h-fav');
      for (var w = 0; w < liste.length; w++) {
        if (String(liste[w].handle || liste[w].id) === k) {
          herzen[q].setAttribute('aria-pressed', 'true');
          break;
        }
      }
    }
  }

  function ausLink(href) {
    var s = String(href || '');
    var teil = s.split('/products/')[1];
    if (!teil) return null;
    var handle = teil.split('?')[0].split('#')[0].split('/')[0];
    if (!handle) return null;
    var vid = 0;
    var q = s.split('variant=')[1];
    if (q) vid = parseInt(q.split('&')[0], 10) || 0;
    return { handle: handle, variant: vid };
  }

  function teileSammeln(detail, knopf) {
    var out = [];
    var zeilen = detail.querySelectorAll('.s4h-lk__teil');
    for (var i = 0; i < zeilen.length; i++) {
      var a = zeilen[i].querySelector('.s4h-lk__teilname');
      if (!a) continue;
      var t = ausLink(a.getAttribute('href'));
      if (!t) continue;
      var gewaehlt = parseInt(zeilen[i].getAttribute('data-vid'), 10);
      if (gewaehlt && zeilen[i].getAttribute('data-waehlbar') === '1') t.variant = gewaehlt;
      out.push(t);
    }
    if (out.length) return out;

    var roh = (knopf.getAttribute('data-handles') || '').split(',');
    for (var j = 0; j < roh.length; j++) {
      var h = String(roh[j] || '').trim();
      if (h) out.push({ handle: h, variant: 0 });
    }
    return out;
  }

  function aufWunschliste(detail, knopf) {
    var teile = teileSammeln(detail, knopf);
    var liste = lesen();
    var neu = 0;

    for (var i = 0; i < teile.length; i++) {
      var h = teile[i].handle;
      var vid = teile[i].variant;
      var vorhanden = null;
      for (var j = 0; j < liste.length; j++) {
        if (String(liste[j].handle || liste[j].id) === h) { vorhanden = liste[j]; break; }
      }
      if (!vorhanden) {
        var eintrag = { id: h, handle: h };
        if (vid) eintrag.variant = vid;
        liste.push(eintrag);
        neu++;
      } else if (vid && !vorhanden.variant) {
        vorhanden.variant = vid;
      }
    }

    try { window.localStorage.setItem(WUNSCH_KEY, JSON.stringify(liste)); }
    catch (e) {
      melden(detail, 'Die Wunschliste lässt sich in diesem Browser nicht speichern.');
      return;
    }

    zaehlerMalen(liste);

    if (neu === 0) melden(detail, 'Alle Teile stehen schon auf deiner Wunschliste.');
    else if (neu === 1) melden(detail, 'Ein Teil auf die Wunschliste gelegt.');
    else melden(detail, neu + ' Teile auf die Wunschliste gelegt.');
  }

  /* ---- Kaufansicht ---------------------------------------- */

  function start(lk) {
    if (lk.dataset.s4hLkBereit === '1') return;
    lk.dataset.s4hLkBereit = '1';

    var wurzel = lk.closest('[id^="shopify-section"]') || lk;
    var detail = lk.querySelector('.s4h-lk__detail');
    if (!detail) return;
    var inner = detail.querySelector('.s4h-lk__inner');

    /* ---- Aus dem Seitenfluss ein Overlay machen ------------
       Pfad, Ueberschrift und .s4h-lk__inner wandern in einen
       Kasten mit role="dialog". Der Kasten ist reine
       Darstellung; an den Inhalten aendert sich nichts. */

    var kasten = detail.querySelector('.s4h-lk__kasten');
    if (!kasten) {
      kasten = document.createElement('div');
      kasten.className = 's4h-lk__kasten';
      kasten.setAttribute('role', 'dialog');
      kasten.setAttribute('aria-modal', 'true');
      kasten.setAttribute('tabindex', '-1');

      var dkopf = detail.querySelector('.s4h-lk__dkopf');
      var titel = dkopf ? dkopf.textContent.trim() : '';
      kasten.setAttribute('aria-label', titel || 'Kaufe den Look');

      var leiste = document.createElement('div');
      leiste.className = 's4h-lk__leiste';

      var pfad = detail.querySelector('.s4h-lk__pfad');
      if (pfad) leiste.appendChild(pfad);

      var zuKnopf = document.createElement('button');
      zuKnopf.type = 'button';
      zuKnopf.className = 's4h-lk__schliessen';
      zuKnopf.setAttribute('aria-label', 'Schließen');
      zuKnopf.appendChild(document.createTextNode('Schließen'));
      var kreuz = document.createElement('span');
      kreuz.setAttribute('aria-hidden', 'true');
      kreuz.textContent = '×';
      zuKnopf.appendChild(kreuz);
      leiste.appendChild(zuKnopf);

      kasten.appendChild(leiste);
      while (detail.firstChild) kasten.appendChild(detail.firstChild);
      detail.appendChild(kasten);
    }

    /* An den <body>, damit kein Vorfahr mit transform oder
       filter die feste Ebene an sich zieht. Die Farbvariablen
       stehen als style-Attribut auf .s4h-lk und ziehen mit. */
    var marke = wurzel.id || 's4h-lk';
    var alte = document.querySelectorAll(
      'body > .s4h-lk__detail[data-s4h-von="' + marke + '"]');
    for (var a = 0; a < alte.length; a++) {
      if (alte[a] !== detail && alte[a].parentNode) alte[a].parentNode.removeChild(alte[a]);
    }
    detail.setAttribute('data-s4h-von', marke);
    var stil = lk.getAttribute('style');
    if (stil) detail.setAttribute('style', stil);
    document.body.appendChild(detail);

    var ausloeser = null;   /* Bild oder Knopf, der geoeffnet hat */
    var scrollAlt = '';

    function punkteZeigen(nr) {
      var p = detail.querySelectorAll('.s4h-lk__punkt');
      for (var i = 0; i < p.length; i++) {
        p[i].hidden = p[i].getAttribute('data-bild') !== String(nr);
      }
    }

    /* Liquid setzt den Korb-Knopf nur, wenn mindestens ein Teil
       ohne Rueckfrage mitgeht. Mit der Groessenwahl gibt es ihn
       immer. Ebenso die Zeile fuer den kurzen Hinweis. */
    function knoepfeSichern() {
      var alles = detail.querySelector('.s4h-lk__alles');
      if (!alles) return;

      if (!alles.querySelector('.s4h-lk__knopf--korb')) {
        var korb = document.createElement('button');
        korb.type = 'button';
        korb.className = 's4h-lk__knopf s4h-lk__knopf--korb';
        korb.textContent = 'In den Warenkorb';
        alles.insertBefore(korb, alles.firstChild);
      }
      var hinweis = alles.querySelector('.s4h-lk__offen');
      if (!hinweis) {
        hinweis = document.createElement('p');
        alles.insertBefore(hinweis, alles.querySelector('.s4h-lk__meldung') || null);
      }
      hinweis.className = 's4h-lk__offen s4h-gr__fehltext';
      hinweis.textContent = '';
    }

    /* ---- Seite dahinter festhalten ------------------------- */

    function sperren() {
      if (document.body.getAttribute('data-s4h-lk-sperre') === '1') return;
      scrollAlt = document.body.style.overflow;
      document.body.setAttribute('data-s4h-lk-sperre', '1');
      document.body.style.overflow = 'hidden';
    }

    function freigeben() {
      if (document.body.getAttribute('data-s4h-lk-sperre') !== '1') return;
      document.body.removeAttribute('data-s4h-lk-sperre');
      document.body.style.overflow = scrollAlt;
    }

    /* ---- Tab bleibt im Kasten (BFSG) ----------------------- */

    function fokusListe() {
      var alle = kasten.querySelectorAll(FOKUSSIERBAR);
      var out = [];
      for (var i = 0; i < alle.length; i++) {
        var el = alle[i];
        if (el.hasAttribute('hidden')) continue;
        if (el.closest('[hidden]')) continue;
        if (!el.offsetWidth && !el.offsetHeight && !el.getClientRects().length) continue;
        out.push(el);
      }
      return out;
    }

    function fokusHalten(e) {
      if (e.key !== 'Tab' || detail.hidden) return;
      var f = fokusListe();
      if (!f.length) { e.preventDefault(); kasten.focus(); return; }
      var erst = f[0];
      var letzt = f[f.length - 1];
      if (!kasten.contains(document.activeElement)) {
        e.preventDefault();
        (e.shiftKey ? letzt : erst).focus();
        return;
      }
      if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
    }

    /* zeigen() und verstecken() aendern NUR das Bild.
       auf() und zu() aendern zusaetzlich den Verlauf. Die
       Trennung ist noetig, weil die Zurueck-Taste das Bild
       aendern muss, ohne den Verlauf noch einmal anzufassen -
       sonst schaukeln sich beide auf. */

    function zeigen(id) {
      var vorlage = document.getElementById('s4h-look-' + id);
      if (!vorlage) return false;
      inner.innerHTML = '';
      inner.appendChild(vorlage.content.cloneNode(true));
      punkteZeigen(1);
      detail.hidden = false;
      lk.classList.add('s4h-lk--offen');
      sperren();

      knoepfeSichern();
      var g = gr();
      if (g) g.anbringen(detail, function () { knopfMalen(detail); });

      kasten.scrollTop = 0;
      try { kasten.focus(); } catch (e) {}
      return true;
    }

    function verstecken() {
      detail.hidden = true;
      inner.innerHTML = '';
      lk.classList.remove('s4h-lk--offen');
      freigeben();
      if (ausloeser && document.contains(ausloeser)) {
        try { ausloeser.focus(); } catch (e) {}
      }
      ausloeser = null;
    }

    function auf(id) {
      if (!zeigen(id)) return;
      try {
        window.history.pushState({ s4hLook: id }, '', '#look-' + id);
      } catch (e) { /* ohne Verlaufseintrag weiter, siehe Kopf */ }
    }

    function zu() {
      var st = window.history.state;
      if (st && st.s4hLook) {
        /* Der Verlauf uebernimmt: popstate ruft gleich
           verstecken(). Nicht hier zusaetzlich schliessen. */
        window.history.back();
        return;
      }
      verstecken();
    }

    window.addEventListener('popstate', function (e) {
      if (!document.contains(detail)) return;
      var st = e.state;
      if (st && st.s4hLook) { zeigen(st.s4hLook); return; }
      if (!detail.hidden) verstecken();
    });

    function aufKlick(e) {
      /* Klick auf den Schleier neben dem Kasten schliesst. */
      if (e.target === detail) { zu(); return; }
      if (e.target.closest('.s4h-lk__schliessen')) { zu(); return; }
      if (e.target.closest('.s4h-lk__zurueck')) { zu(); return; }

      var korb = e.target.closest('.s4h-lk__knopf--korb');
      if (korb) { inKorb(lk, detail, korb); return; }

      var wunsch = e.target.closest('.s4h-lk__knopf--wunsch');
      if (wunsch) { aufWunschliste(detail, wunsch); return; }

      var m = e.target.closest('.s4h-lk__mini');
      if (m) {
        var gross = detail.querySelector('.s4h-lk__grossbild');
        if (gross) gross.src = m.getAttribute('data-gross');
        punkteZeigen(m.getAttribute('data-nr'));
        var alle = detail.querySelectorAll('.s4h-lk__mini');
        for (var i = 0; i < alle.length; i++) alle[i].classList.remove('on');
        m.classList.add('on');
        return;
      }

      var k = e.target.closest('[data-s4h-look]');
      if (k) {
        ausloeser = k;
        auf(k.getAttribute('data-s4h-look'));
      }
    }

    /* Zwei Zuhoerer, weil das Overlay seit dem 04.09. am <body>
       haengt und damit kein Nachfahre von .s4h-lk mehr ist. Sie
       ueberschneiden sich nicht. */
    lk.addEventListener('click', aufKlick);
    detail.addEventListener('click', aufKlick);

    document.addEventListener('keydown', function (e) {
      if (!document.contains(detail)) return;
      if (e.key === 'Escape' && !detail.hidden) { zu(); return; }
      fokusHalten(e);
    });

    /* Adresse mit #look-l1 oeffnet den Look direkt. */
    var ausAdresse = (window.location.hash || '').replace('#look-', '');
    if (ausAdresse && document.getElementById('s4h-look-' + ausAdresse)) {
      zeigen(ausAdresse);
      try {
        window.history.replaceState({ s4hLook: ausAdresse }, '', window.location.href);
      } catch (e) {}
    }
  }

  function boot() {
    var alle = document.querySelectorAll('.s4h-lk');
    for (var i = 0; i < alle.length; i++) start(alle[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
